import { Box, HStack, Image, Text } from '@chakra-ui/react'
import { H1, Link } from 'ui'
import { ImageLoadingPreference } from 'utils'

interface DetailPageHeaderProps {
  linkHeading?: string
  provider?: string
  heading: string
  linkHref?: string
  logoUrl: string
}

const DetailPageHeader = ({
  linkHeading,
  provider,
  heading,
  linkHref,
  logoUrl,
}: DetailPageHeaderProps) => {
  return (
    <Box mb={{ base: '35px', lg: '50px' }}>
      <HStack justifyContent="space-between" mb={5}>
        <Box>
          <Text
            mb={0}
            sx={{
              pr: '24px',
              'html[lang=ar] &': {
                pr: 'unset',
                pl: '24px',
              },
            }}
            width={{ base: '222px', lg: '100%' }}
          >
            {linkHeading}
          </Text>
          {linkHref && (
            <Link
              textDecoration="none"
              href={linkHref}
              aria-label={provider}
              fontSize={{ lg: '20px' }}
              fontFamily="enz500"
            >
              {provider}
            </Link>
          )}
        </Box>
        {logoUrl && (
          <Image
            onError={(event) => {
              event.currentTarget.style.display = 'none'
            }}
            boxSize={{ base: '80px', lg: '180px' }}
            src={logoUrl}
            alt={`${provider} logo`}
            position={{ lg: 'absolute' }}
            right={{ lg: 16 }}
            top={{ lg: '100px' }}
            objectFit="contain"
            loading={ImageLoadingPreference.LAZY}
            sx={{
              'html[lang=ar] &': {
                right: 'unset',
                left: { lg: 16 },
              },
            }}
          />
        )}
      </HStack>
      <H1 mb={0} maxW={{ lg: 'calc(100% - 200px)' }}>
        {heading}
      </H1>
    </Box>
  )
}

export default DetailPageHeader
